import React, { useEffect, useRef, useState } from 'react';
import { useForm } from 'react-hook-form';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { TimePicker } from '@mui/x-date-pickers';
import dayjs from 'dayjs';
import Select from "react-select";
import * as appActions from "../../../core/app.store";
import { useDispatch } from 'react-redux';
import { optionsCustomerStatus } from '../../../common/constant';
import { patternNumber } from '../../../common/validatePhoneNumber';
import { getUserInfo } from '../../../utils/configuration';

export default function FormAssignHerdsman(props) {
    const { triggerSubmit, setTriggerSubmit, onCloseModal, updateItem, customerForCreateTask,
        herdsman, handleSubmitAddEditTask,} = props;
    const buttonSubmitRef = useRef(null);
    const [optionsHerdsman, setOptionsHerdsman] = useState(herdsman.map(item => {return {label: item.name, value: item.id}}));
    
    const [currentLoggedInHerdsman] = useState({ label: getUserInfo()?.fullName, value: getUserInfo()?.herdsmanId });

    useEffect(() => {
        console.log(updateItem);
        setValue("herdsmanId1", updateItem?.herdsmanHelpingId1);
        setValue("herdsmanId2", updateItem?.herdsmanHelpingId2);
    }, [])

    const { register, handleSubmit, errors, setValue, control } = useForm({
        mode: "all",
        reValidateMode: "onBlur",
    });

    const onSubmit = (data) => {
        if (!data) {
          return;
        }
        
        const dataInput = {
            ...data, CalendarId: updateItem?.id
        }

        handleSubmitAddEditTask(dataInput);
        onCloseModal();
    }

    useEffect(()=>{
        if (!triggerSubmit) return;
        buttonSubmitRef.current.click();
        setTriggerSubmit(false);
    }, [triggerSubmit])

    return (
        <form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
            <div className="row">
                <div className="form-group col-md-6">
                    <label>Swat <span className='required'>*</span></label>
                    <Select
                         isClearable
                        {...register("herdsmanId1", {  })}
                        defaultValue={updateItem?.herdsmanHelpingId1 ? { label: updateItem?.herdsmanHelpingName1, value: updateItem?.herdsmanHelpingId1 } : null}
                        placeholder="Swat"
                        onChange={(data) => setValue("herdsmanId1", data ? data.value : null)}
                        options={optionsHerdsman}
                    />
                </div>
                <div className="form-group col-md-6">
                    <label>Swat <span className='required'>*</span></label>
                    <Select
                        isClearable
                        {...register("herdsmanId2", { })}
                        defaultValue={updateItem?.herdsmanHelpingId2 ? { label: updateItem?.herdsmanHelpingName2, value: updateItem?.herdsmanHelpingId2 } : null}
                        placeholder="Swat"
                        onChange={(data) => setValue("herdsmanId2", data ? data.value : null)}
                        options={optionsHerdsman}
                    />
                </div>
            </div>
            <button ref={buttonSubmitRef} style={{display: "none"}} type="submit" className="btn btn-primary">
              Lưu
            </button>
        </form>
    )
}